export enum EmailProvideType {
  BASIC = 'BASIC',
  MICROSOFT = 'MICROSOFT',
  GOOGLE = 'GOOGLE'
}